import { Sort } from './sort.data';

export interface BoxPageRequest {
  page?: number;
  size?: number;
  sort?: Sort;
  searchText?: string;
  assigned?: boolean;
}

export namespace BoxPageRequest {
  export function mapToQuery({ page, size, searchText, sort, assigned }: BoxPageRequest): any {
    return {
      page,
      size,
      ...(searchText && { searchText }),
      ...(sort?.sortBy && sort?.direction && { sort: Sort.mapToQueryParam(sort) }),
      ...(assigned != null && { assigned }),
    };
  }
}
